<div class="step-progress">
  <span *ngFor="let step of steps; let i = index" class="step" [ngClass]="i+1 <= stepProgress ? progressClasses : 'base'"></span>
</div>